// @ts-check

import { Dropdown } from "antd";
import { CheckCircleOutlined, ExpandAltOutlined } from "@ant-design/icons";
import { useEffect, useMemo, useState } from "react";
import { LocalStorageHelper } from '~/other/Helper';

const LayoutWidth = {
    DEFAULT: "1100px",
    WIDE: "1500px",
    FULL_WIDTH: "100vw",
};

const updateMaxDesktopWidth = (width) => {
    document.body.style.setProperty("--max-desktop-width", width);
    LocalStorageHelper.set("max-desktop-width", width);
    if (width !== LayoutWidth.DEFAULT) {
        document.body.style.setProperty("--inline-sidebar-left-margin", "1rem");
    } else {
        document.body.style.setProperty("--inline-sidebar-left-margin", "0px");
    }
};

export default function LayoutDropdown() {
    const [currentLayout, setCurrentLayout] = useState(LayoutWidth.DEFAULT);

    useEffect(() => {
        const maxDesktopWidth = LocalStorageHelper.get("max-desktop-width");
        if (maxDesktopWidth) {
            updateMaxDesktopWidth(maxDesktopWidth);
            setCurrentLayout(maxDesktopWidth);
        }
    }, []);

    const clickHandler = ({ key }) => {
        updateMaxDesktopWidth(key);
        setCurrentLayout(key);
    };

    const dropdownItem = (key, label) => {
        return {
            key,
            label: <>{label} {currentLayout === key ? <CheckCircleOutlined /> : null}</>,
        };
    };

    const dropdownItems = useMemo(() => {
        return [
            dropdownItem(LayoutWidth.DEFAULT, "Normal"),
            dropdownItem(LayoutWidth.WIDE, "Wide"),
            dropdownItem(LayoutWidth.FULL_WIDTH, "Full Width"),
        ];
    }, [currentLayout]);

    if (window.screen.width <= parseInt(LayoutWidth.DEFAULT)) {
        return null;
    }

    return (
        <Dropdown
            trigger={["click"]}
            menu={{
                onClick: clickHandler,
                items: dropdownItems,
            }}
        >
            <button className="ButtonLink no-hover">
                <ExpandAltOutlined style={{ color: "white", fontSize: "20px", marginTop: "5px" }} />
            </button>
        </Dropdown>
    );
}
